export default __webpack_public_path__ + "static/media/NextArrow.dec4b441.svg";